import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { create } from 'zustand';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
export const shouldShowFeedbackBar = (feedbackEligibleMessageId, submittedFeedbackIds)=>feedbackEligibleMessageId != null && !submittedFeedbackIds.has(feedbackEligibleMessageId);
const emptyState = {
    conversationId: null,
    messages: [],
    isThinking: false,
    thinkingLabel: null,
    transportError: null,
    feedbackEligibleMessageId: null,
    feedbackEligibleRenderedId: null,
    submittedFeedbackIds: new Set(),
    isRecovering: false,
    recoveryFailed: false,
    recoveryRetryable: true
};
export const useAnalystChatStore = create((set)=>_object_spread_props(_object_spread({}, emptyState), {
        startConversation: (id)=>set({
                conversationId: id
            }),
        appendUserMessage: (text)=>set((state)=>({
                    messages: [
                        ...state.messages,
                        {
                            id: generateUniqueId('msg'),
                            role: 'user',
                            text
                        }
                    ],
                    transportError: null
                })),
        beginTurn: ()=>set({
                isThinking: true,
                transportError: null,
                recoveryFailed: false
            }),
        setThinkingLabel: (label)=>set({
                thinkingLabel: label
            }),
        appendAssistantContent: (part)=>set((state)=>({
                    messages: [
                        ...state.messages,
                        {
                            id: generateUniqueId('msg'),
                            role: 'assistant',
                            part
                        }
                    ]
                })),
        finalizeTurn: ()=>set({
                isThinking: false,
                thinkingLabel: null
            }),
        failTransport: (kind)=>set({
                transportError: kind,
                isThinking: false,
                thinkingLabel: null
            }),
        hydrate: (messages)=>set({
                messages,
                transportError: null,
                isThinking: false,
                thinkingLabel: null,
                isRecovering: false,
                recoveryFailed: false,
                feedbackEligibleMessageId: null,
                feedbackEligibleRenderedId: null
            }),
        markTurnDone: (messageId)=>set((state)=>{
                var _ref;
                const lastAssistant = [
                    ...state.messages
                ].reverse().find((message)=>message.role === 'assistant');
                return {
                    feedbackEligibleMessageId: messageId,
                    feedbackEligibleRenderedId: (_ref = lastAssistant === null || lastAssistant === void 0 ? void 0 : lastAssistant.id) !== null && _ref !== void 0 ? _ref : null,
                    isThinking: false,
                    thinkingLabel: null,
                    isRecovering: false
                };
            }),
        markFeedbackSubmitted: (messageId)=>set((state)=>({
                    submittedFeedbackIds: new Set([
                        ...state.submittedFeedbackIds,
                        messageId
                    ])
                })),
        beginRecovery: ()=>set({
                isRecovering: true,
                recoveryFailed: false,
                transportError: null
            }),
        failRecovery: function failRecovery() {
            let retryable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            return set({
                isRecovering: false,
                recoveryFailed: true,
                recoveryRetryable: retryable,
                isThinking: false
            });
        },
        reset: ()=>set(_object_spread({}, emptyState))
    }));
